// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as CountryContext from "../../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as CrmRepoManager from "../../../../../to-be-migrated/domain/repo/CrmRepoManager.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as GenericListView$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/GenericListView.bs.js";

var getColumnSchema_0 = {
  column: {
    TAG: /* Text */0,
    _0: "Opt-in Timestamp"
  },
  accessor: (function ($$document) {
      return {
              TAG: /* Text */0,
              _0: DeccoUtils$Catalyst.DateUtils.t_encode($$document.startDateTime)
            };
    })
};

var getColumnSchema_1 = {
  hd: {
    column: {
      TAG: /* Text */0,
      _0: "Opt-out Timestamp"
    },
    accessor: (function ($$document) {
        return {
                TAG: /* Text */0,
                _0: Belt_Option.mapWithDefault($$document.endDateTime, "", (function (x) {
                        return DeccoUtils$Catalyst.DateUtils.t_encode(x);
                      }))
              };
      })
  },
  tl: /* [] */0
};

var getColumnSchema = {
  hd: getColumnSchema_0,
  tl: getColumnSchema_1
};

var ListRecord = {};

var ListView = GenericListView$Catalyst.Make(ListRecord);

function fetchData(msisdn, offset, succFunc, errFunc, country) {
  var RepoInstance = CrmRepoManager.getServiceabilityRepo(undefined);
  return ApiUtils$Catalyst.handleAPIRequest((function (param) {
                return Curry._3(RepoInstance.getOutStationServiceabilityInfo, msisdn, offset, country);
              }), (function (data) {
                return Curry._1(succFunc, {
                            recs: Belt_Option.mapWithDefault(data.sessions, /* [] */0, (function (x) {
                                    return x;
                                  })),
                            offset: data.offset_value
                          });
              }), Curry.__1(errFunc));
}

function OutStationServiceabilityListView(Props) {
  var msisdn = Props.msisdn;
  var match = CountryContext.useContext(undefined);
  var country = match.country;
  return React.createElement(ListView.make, {
              columns: getColumnSchema,
              fetchData: (function (param) {
                  var func = function (param$1, param$2, param$3) {
                    return fetchData(msisdn, param, param$1, param$2, param$3);
                  };
                  return function (param) {
                    var func$1 = Curry._1(func, param);
                    return function (param) {
                      return Curry._2(func$1, param, country);
                    };
                  };
                })
            });
}

var make = OutStationServiceabilityListView;

export {
  getColumnSchema ,
  ListRecord ,
  ListView ,
  fetchData ,
  make ,
  
}
/* ListView Not a pure module */
